import { render, staticRenderFns } from "./EventoHospedagem.vue?vue&type=template&id=504d81fa&scoped=true"
import script from "./EventoHospedagem.vue?vue&type=script&lang=js"
export * from "./EventoHospedagem.vue?vue&type=script&lang=js"
import style0 from "./EventoHospedagem.vue?vue&type=style&index=0&id=504d81fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "504d81fa",
  null
  
)

export default component.exports